import React from 'react';
import slider1 from '../../../assets/images/educational_service/writing_book.jpg';
import slider2 from '../../../assets/images/educational_service/writing_book_two.jpg';
import slider3 from '../../../assets/images/educational_service/soft_floor.jpg';
import CrossFadeImageSlider from '../../../components/molecules/CrossFadeImageSlider';

function EducationalResources() {
  const images = [
    {
      src: slider1,
      alt: 'Occupational therapy handwriting practice in Wasilla, Alaska',
    },
    {
      src: slider2,
      alt: 'Pediatric therapy group session in Wasilla clinic',
    },
    {
      src: slider3,
      alt: 'Occupational therapy sensory gym in Wasilla pediatric clinic',
    },
  ];

  return (
    <section>
      <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
        <h1 className="text-[32px] sm:text-[42px] md:text-[48px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px] md:mr-4">
          Guidepost Pediatric <br /> Resources
        </h1>
        <div className="flex flex-col md:flex-row justify-between w-full gap-4 sm:gap-10 xl:gap-32">
          <div className="flex-[50%] flex flex-col items-start gap-4 sm:gap-6 lg:gap-10 text-lg md:text-xl 2xl:text-2xl text-secondary leading-10">
            <p>
              Explore our collection of resources, including informative blog
              posts, insightful podcasts, and valuable parent education
              materials, designed to provide you with valuable insights,
              guidance, and support on your journey through your child's
              development. Guidepost Pediatrics is a Medbridge clinic. Parents
              are encouraged to download the Medbridge App and ask their
              therapist about the educational lesson plans for physical therapy,
              occupational therapy, and speech therapy to continue working
              toward therapy goals at home. Our sessions do not just last for
              just an hour, but instead continue far past the therapy session
              with the Medbridge educational program.
            </p>
            <p>
              Also, ask about our new 504 advocacy program that helps support
              parents through IEP and 504 processes for special education
              students and patients. We have experts on staff to help your child
              receive the support they deserve in the classroom. Contact the
              front desk for more information{' '}
              <span className="text-pink">907-376-4880.</span>
            </p>
          </div>
          <div className="flex-[50%] flex overflow-hidden justify-center relative">
            <CrossFadeImageSlider
              width="w-[90vw] md:w-[700px] 2xl:w-[800px] "
              height="h-[500px] 2xl:h-[670px] "
              images={images}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default EducationalResources;
